module.exports = __webpack_public_path__ + "static/media/6.43ad0b47.jpg";